/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';

// Enhanced impact metrics for partner credibility
const impactMetrics = [
  {
    number: '2M+',
    label: 'Downloads',
    description: 'Across all platforms worldwide',
    icon: 'M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4',
  },
  {
    number: '300K+',
    label: 'Active Users',
    description: 'Monthly active users',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
  },
  {
    number: '50+',
    label: 'Apps Published',
    description: 'Successfully released products',
    icon: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z',
  },
  {
    number: '4.7',
    label: 'Avg Rating',
    description: 'User satisfaction score',
    icon: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z',
  },
  {
    number: '20+',
    label: 'Team Members',
    description: 'Expert developers & designers',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
  },
  {
    number: '2',
    label: 'Years Experience',
    description: 'Building successful apps',
    icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  },
];

export default function Achievement() {
  return (
    <section className="py-20 bg-theme-blue relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-theme-purple rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-16">
            <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3">
              Our Impact
            </p>
            <h2 className="text-4xl md:text-5xl text-white font-bold mb-4">
              Numbers That Speak
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Building trust through consistent delivery and measurable results
            </p>
          </div>
        </Fade>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {impactMetrics.map((metric, index) => (
            <Fade key={metric.label} direction="up" delay={index * 100} triggerOnce>
              <div className="group text-center p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300 cursor-pointer">
                {/* Icon */}
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-theme-purple/20 flex items-center justify-center group-hover:bg-theme-purple/30 transition-colors">
                  <svg
                    className="w-6 h-6 text-theme-purple"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={metric.icon} />
                  </svg>
                </div>

                {/* Number */}
                <p className="text-3xl md:text-4xl font-bold text-white mb-1">
                  {metric.number}
                </p>

                {/* Label */}
                <p className="text-sm font-medium text-theme-purple mb-1">
                  {metric.label}
                </p>

                {/* Description */}
                <p className="text-xs text-gray-400">
                  {metric.description}
                </p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
}
